export default "__VITE_ASSET__c18795da__"